// extracted by mini-css-extract-plugin
module.exports = {"StickersBlock":"styles_StickersBlock__2zpa1"};